import { render } from "./HotelDescription.vue?vue&type=template&id=a6d86766&scoped=true"
import script from "./HotelDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelDescription.vue?vue&type=script&setup=true&lang=js"

import "./HotelDescription.vue?vue&type=style&index=0&id=a6d86766&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d86766"],['__file',"src/components/Event/HotelDescription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6d86766"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6d86766', __exports__)) {
    api.reload('a6d86766', __exports__)
  }
  
  module.hot.accept("./HotelDescription.vue?vue&type=template&id=a6d86766&scoped=true", () => {
    api.rerender('a6d86766', render)
  })

}


export default __exports__